<template>
    <div>
        <validation-observer ref="observer" v-slot="{ passes, invalid }">
            <b-modal title="Manual Moved item"  ok-title="Confirm" ok-only
                     v-model="moveModal"
                     :ok-disabled="invalid"
                     @ok="moveItemReason">
                <h5>Please enter reasons for moving manually:</h5>
                <b-form>
                    <validation-provider
                            name="Reason"
                            :rules="{  }"
                            immediate
                            v-slot="validationContext"
                    >
                        <b-form-group
                                label="Reason"
                                label-for="secure-bag-metal">
                            <b-form-input :type="'text'" v-model="moveReason"
                            ></b-form-input>
                        </b-form-group>
                    </validation-provider>
                </b-form>
            </b-modal>
        </validation-observer>
        <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    per-page="5"
                    align="fill"
                    size="sm"
                    class="my-1"
                    limit="14"
                    first-number
                    last-number
                    ></b-pagination>
        <div class="batch-scroll">
            <div style="min-height:10px;" :id="grouping + '?'">
                <b-table
                :items="localStatuses"
                :fields="['component_id', 'type', 'metal', 'weight']"
                :filter="search"
                :busy="isBusy"
                small
                fixed
                per-page="5"
                :current-page="currentPage"
                class="text-left depth-0">
                <template #table-busy>
                    <LoadingSpinner :busy="isBusy"/>
                </template>
                    <template #cell(component_id)="data">
                        <i class="mr-1 fa-fw fa-solid fa-inbox fa-sm" v-if="status != 'binned'" style="line-height: 1.5em; cursor: pointer;"
                        @click="moveItem('binned', data.item)" v-b-tooltip.hover.viewport title="Move to Binned"></i>
                        <i class="mr-1 fa-fw fa-solid fa-tags text-success fa-sm" v-if="status != 'pulled'" style="line-height: 1.5em; cursor: pointer;"
                        @click="moveItem('pulled', data.item)" v-b-tooltip.hover.viewport title="Move to Recently Held" ></i>
                        <i class="mr-1 fa-fw fa-solid fa-magnet fa-sm" style="color: #c40285; line-height: 1.5em; cursor: pointer;" v-if="status != 'zero-value'"
                        @click="moveItem('zero-value', data.item)" v-b-tooltip.hover.viewport title="Move to Zero-value"></i>
                        <i class="mr-1 fa-fw fa-solid fa-question-circle text-danger fa-sm" v-if="status != 'exception'" style="line-height: 1.5em; cursor: pointer;"
                        @click="moveItem('exception', data.item)" v-b-tooltip.hover.viewport title="Move to Exception"></i>
                        {{ data.value }}
                    </template>
                    <template #cell(metal)="data">{{  data.value | titleCase }}</template>
                    <template #row-details="row">
                        <b-table
                        :items="row.item.child_items"
                        :fields="['component_id', 'type', 'metal', 'weight']"
                        :filter="search"
                        small
                        fixed
                        borderless
                        thead-class="d-none"
                        class="ml-4 mb-0 text-left font-sm depth-1">
                            <template #cell(component_id)="data">
                                <i class="mr-1 fa-fw fa-solid fa-inbox fa-sm text-dark" v-if="status != 'binned'" style="line-height: 1.5em; cursor: pointer;"
                                @click="moveItem('binned', data.item)" v-b-tooltip.hover.viewport title="Move to Binned"></i>
                                <i class="mr-1 fa-fw fa-solid fa-tags text-success fa-sm" v-if="status != 'pulled'" style="line-height: 1.5em; cursor: pointer;"
                                @click="moveItem('pulled', data.item)" v-b-tooltip.hover.viewport title="Move to Recently Held" ></i>
                                <i class="mr-1 fa-fw fa-solid fa-magnet fa-sm" style="color: #c40285; line-height: 1.5em; cursor: pointer;" v-if="status != 'zero-value'"
                                @click="moveItem('zero-value', data.item)" v-b-tooltip.hover.viewport title="Move to Zero-value"></i>
                                <i class="mr-1 fa-fw fa-solid fa-question-circle text-danger fa-sm" v-if="status != 'exception'" style="line-height: 1.5em; cursor: pointer;"
                                @click="moveItem('exception', data.item)" v-b-tooltip.hover.viewport title="Move to Exception"></i>
                                {{ data.value }}
                            </template>
                            <template #cell(metal)="data">{{  data.value | titleCase }}</template>
                            <!-- <template #row-details="row">
                                <b-table :items="row.item.child_items" :fields="['component_id', 'type', 'metal', 'weight']" small fixed borderless thead-class="d-none" class="ml-2 mb-0 text-left font-xs font-italic depth-2">
                                </b-table>
                            </template> -->
                        </b-table>
                    </template>
                </b-table>
            </div>
            <!-- ******************** END OF Bags ****************** -->
        </div>

    </div>
</template>



<script>
    import _ from 'lodash';
    import LoadingSpinner from '@/components/LoadingSpinner';
    export default {
        name: 'batch-order-table-no-menu',
        components: {
            LoadingSpinner,
        },
        props: ['items', 'path', 'orderItem', 'statuses', 'orderStatues', 'seekAndRemove', 'replace', 'status','seekItemsCallback', 'grouping', 'loading', 'search', 'lastMoveAttempt', 'lastMoveAttemptSet'],
        data() {
            return {
                localStatuses: [],
                cacheLocal: [],
                movedItem: null,
                moveReason: '',
                moveModal: false,
                totalRows: 0,
                currentPage: 1,
                isBusy: false,
            };
        },
        created() {
            this.doUpdate();
            // window.addEventListener('click', (event) => {
            //     this.$root.$emit('bv::hide::popover');
            // });
        },
        updated: function () {
            this.$nextTick(function () {
                this.isBusy = false;
            });
        },
        methods: {
            moveItemReason() {
                this.$http.post('/batch/updateItem/' + this.movedItem, {'reason': this.moveReason});
            },
            startReason(id) {
                this.movedItem = id;
                this.moveReason = '';
                this.moveModal = true;
            },
            getValidationState({dirty, validated, valid = null}) {
                return dirty || validated ? valid : null;
            },
            compare(left, right) {
                if((left == null || right == null) && left != right) {
                    return true;
                }
                else if(left == null && left == right) {
                    return false;
                }
                if(left.length != right.length){
                    return true;
                }
                for(let i = 0; i < left.length; i++) {
                    if (left[i].id != right[i].id) {
                        return true;
                    }
                    if(this.compare(left[i].child_items, right[i].child_items)) {
                        return true;
                    }
                }
                return false;
            },
            whatMoved(newer, original, parent_id = null) {
                let ids = [];
                _.forEach(newer, (newItem) => {
                    if (original) {
                        for (let i = 0; i < original.length; i++) {
                            if (newItem.id == original[i].id) {
                                let childIds = this.whatMoved(newItem.child_items, original[i].child_items, newItem.id);
                                _.forEach(childIds, (item) => {
                                    ids.push(item);
                                });
                                return;
                            }
                        }
                    }
                    newItem.parent_id = parent_id;
                    ids.push({id:newItem.id, parent_id: parent_id});
                });
                return ids;
            },
            canBeChildOf(parent, child) {
                if(parent.container_type == 'list') {
                    //fix setting items back to original areas.
                    return parent.canMoveTo;
                } else if (parent.container_type == 'bag') {
                    console.log(_.findIndex(parent.container.inventory, (e) => {return e.id == child.container.id;}));
                    return _.findIndex(parent.container.inventory, (e) => {return e.id == child.container.id;}) != -1;
                }
                else if (parent.container_type == 'inventory') {
                    console.log(child.container, parent.container.children);
                    console.log(_.findIndex(parent.container.children, (e) => {return e.id == child.container.id;}));
                    return _.findIndex(parent.container.children, (e) => {return e.component_id == child.container.component_id;}) != -1;
                }
                return false;
            },
            checkMove(e, bag) {
                if(!this.loading && this.canBeChildOf(this.seekItemsCallback(e.to.id),e.draggedContext.element)){
                    return true;
                }
                //do not allow repositioning
                return false;
            },

            // signals parent to move bags from one section to another
            moveItem(section, item) {
                if(!this.loading) {
                    this.lastMoveAttemptSet('right-click');
                    this.startReason(item.id);
                    this.seekAndRemove(item);
                    this.statuses[section].items.push(item);
                    this.$forceUpdate();
                    this.$root.$emit('bv::hide::popover');
                }
            },
            rightClickHandler(e, row) {
                if(!this.loading) {
                    this.$root.$emit('bv::hide::popover');
                    let popover = 'click-control-' + row.id;
                    this.$root.$emit('bv::show::popover', popover);
                }
            },
            updateItems(newer, original, canUpdate) {
                let items = this.whatMoved(newer, original);
                if(this.status) {
                    if (canUpdate && items[0]) {
                        this.startReason(items[0].id);
                    }
                    _.forEach(items, (item) => {
                        item.status = this.status;
                        //remove ~, this is a counter, if null, it was a drag event.
                        if(!this.loading) {
                            item = _.cloneDeep(item); //prevents certain silly issues.
                            console.log('Read Attempt');
                            item.move_type = (this.lastMoveAttempt ? this.lastMoveAttempt : 'drag').replaceAll('~', '');
                            this.$http.post('/batch/updateItem/' + item.id, item);
                        }
                    });
                }
                else {
                    console.log('NO STATUS BUG');
                }
                return items.length > 0;
            },
            doUpdate(canUpdate) {
                function customizer(value) {
                    if (_.isArray(value)) {
                        return value.reduce((acc, el) => {
                            el._showDetails = true;
                            acc.push(_.cloneDeepWith(el, customizer));
                            return acc;
                        }, []);
                    }
                }
                let updated = false;
                if (this.compare(this.cacheLocal, this.items)) {
                    updated = this.updateItems(this.items,this.cacheLocal, canUpdate);
                    this.localStatuses = _.cloneDeepWith(this.items, customizer);
                    this.cacheLocal = _.cloneDeepWith(this.localStatuses, customizer);
                }
                if(this.compare(this.localStatuses, this.cacheLocal)) {
                    updated = this.updateItems(this.localStatuses, this.cacheLocal, canUpdate);
                    this.replace(_.cloneDeepWith(this.localStatuses, customizer));
                    this.cacheLocal = _.cloneDeepWith(this.localStatuses, customizer);
                }
                this.totalRows = this.localStatuses.length;
                if (updated && !this.loading && this.lastMoveAttempt) { //if null, no action needed. must be active item update, must not be loading page.
                    //decrement ~ count, if no ~, than set it to empty. ~ is used to count.
                    let copy = this.lastMoveAttempt;
                    console.log('Write Attempt ' + copy);
                    copy = copy.replace('~', '');
                    if (copy == this.lastMoveAttempt) {
                        copy = null;
                    }
                    console.log('POST WRITE -  ' + copy);
                    this.lastMoveAttemptSet(copy);
                }
            }
        },
        computed: {

        },
        watch: {
            items: {
                deep: true,
                handler() {
                    this.doUpdate(false);
                }
            },
            localStatuses: {
                deep: true,
                handler(value) {
                    this.doUpdate(true);
                }
            },
            totalRows(value) {
                this.$nextTick(()=> {
                    this.currentPage = Math.ceil(value / 5);
                });
            },
            search(value) {
                if (value) {
                    this.currentPage = 1;
                }
            },
        }
    };
</script>

<style scoped>


    .batch-scroll {
        max-height: 400px;
        overflow: scroll;
        overflow-x: hidden;
    }

    .depth-0 {
        color: #000;
    }
    .depth-1 {
        padding-left: 15px;
        color: #13b0df;
    }
    .depth-2 {
        padding-left: 25px;
        color: #7ac1d9;
    }

</style>
